import { z } from 'zod';
import {
  LoginRequestSchema,
  LoginResponseSchema,
  PasswordResetRequestSchema,
  PasswordResetResponseSchema,
  RefreshResponseSchema,
  SetPasswordRequestSchema,
} from '@visep/shared-types/auth';
import type {
  LoginRequest,
  LoginResponse,
  PasswordResetRequest,
  PasswordResetResponse,
  RefreshResponse,
  SetPasswordRequest,
} from '@visep/shared-types/auth';
import type { Helpers } from './internal.js';

export function createAuthResource({ request }: Helpers) {
  return {
    async login(input: LoginRequest): Promise<LoginResponse> {
      const parsed = LoginRequestSchema.parse(input);
      return LoginResponseSchema.parse(await request('POST', '/api/auth/login', parsed));
    },
    async refresh(): Promise<RefreshResponse> {
      return RefreshResponseSchema.parse(await request('POST', '/api/auth/refresh'));
    },
    async logout(): Promise<void> {
      await request('POST', '/api/auth/logout');
    },
    async setPassword(input: SetPasswordRequest): Promise<{ ok: true }> {
      const parsed = SetPasswordRequestSchema.parse(input);
      return z
        .object({ ok: z.literal(true) })
        .parse(await request('POST', '/api/auth/set-password', parsed));
    },
    async passwordReset(input: PasswordResetRequest): Promise<PasswordResetResponse> {
      const parsed = PasswordResetRequestSchema.parse(input);
      return PasswordResetResponseSchema.parse(
        await request('POST', '/api/auth/password-reset', parsed),
      );
    },
  };
}
